// 定数を定義
export const TEXT = 1;
export const HEADING_LARGE = 2;
export const IMAGE = 3;
export const YOUTUBE = 4;
export const FREE = 5;
export const HEADING_MEDIUM = 6;
export const HEADING_SMALL = 7;
export const INSTAGRAM = 8;
export const DELETE = 9;
export const NOTE = 10;
export const COURSE = 100;

export const enterContent = {
  id: '',
  body: '',
  sort_order: 9999999,
  content_type: TEXT,
  referenced_course_id: null,
};
